import Head from 'next/head'
import { gtm, isDev } from 'constants/analytics'
import Script from './Script'
import { useEffect } from 'react'

export default function GTM() {
	if ( isDev() ) return null

	return (
		<>
			<Head>
				<Script>
					{`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
					new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
					j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
					'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
					})(window,document,'script','dataLayer','${gtm}');`}
				</Script>
			</Head>
		</>
	)
}

export function GTMPush({ event, ecommerce }) {
	useEffect( () => gtmPush({ event, ecommerce }), [] )
	return null
}

export function gtmPush({ event, ecommerce }) {
	if ( isDev() ) return console.log( 'dataLayer.push', { event, ecommerce })
	if ( !window.dataLayer ) return console.error( 'dataLayer not loaded' )

	window.dataLayer.push({ ecommerce: null })
	window.dataLayer.push({ event, ecommerce })
}
